<template>
  <div class="moondayCard" @click="toDetail(note)" v-if="note">
    <div class="moondayCard__header">
      <div
        class="moondayCard__header__info"
        :class="{ infoWrap: splitMood(note.Moods).length > 1 }"
      >
        <div class="moondayCard__header__info__emotionGroup">
          <div
            class="moondayCard__header__info__emotionGroup__emotion"
            v-for="mood in splitMood(note.Moods)"
            :key="mood"
            :style="`background-color:${
              emotionList.find((e) => e.id === mood).color
            }`"
          >
            <img :src="emotionList.find((e) => e.id === mood).active_icon" />
          </div>
        </div>
        <div class="moondayCard__header__info__text">
          <div class="moondayCard__header__info__text__title">
            {{ moment(note.Date).format("MM/DD") }} {{ note.Title }}
            <div
              class="moondayCard__header__info__text__title__platform"
              v-show="nowloginPlatform !== note.Platform"
            >
              {{ note.Platform }}
            </div>
          </div>
        </div>
      </div>
      <div class="moondayCard__header__option">
        <div class="option__group option__group--gapLarge">
          <div class="option__group__item">
            <img
              src="@/assets/icon-delete.svg"
              title="刪除"
              @click.stop="onDelete(note)"
            />
          </div>
          <div class="option__group__item">
            <img
              src="@/assets/icon-edit.svg"
              title="編輯"
              @click.stop="onEdit(note)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="moondayCard__line">
      <span></span
      ><img src="@/assets/月亮日記/卡片分隔線.svg" alt="" /><span></span>
    </div>
    <div class="moondayCard__body">
      <div
        class="moondayCard__body__content"
        v-html="highlightKeyword(note.Content)"
      ></div>
    </div>
  </div>
</template>
  
  <script>
import moment from "moment";
import emotionList from "@/js/emotionList.js";

export default {
  name: "AstroCalendarNoteCard",
  props: ["note", "nowloginPlatform"],
  data() {
    return {
      emotionList,
    };
  },
  methods: {
    moment,
    splitMood(moods) {
      return moods.split("|");
    },
    highlightKeyword(content) {
      const keyword = this.$parent.filterKey; // 從 parent 取得關鍵字
      if (!keyword) return content;
      const reg = new RegExp(keyword, "g");
      const matched = content.match(reg);
      let copy = content;
      if (matched) {
        const index = content.indexOf(keyword);
        if (index > 60) {
          content = copy.slice(0, 40) + "..." + copy.slice(index - 10);
        }
        return content.replace(reg, `<span class="keyword">${keyword}</span>`);
      }
      return content;
    },
    onEdit(note) {
      this.$emit("edit", note);
    },
    onDelete(note) {
      this.$emit("delete", note);
    },
    toDetail(note) {
      this.$emit("detail", note);
    },
  },
};
</script>
  
<style lang="scss" scoped>
@import "@/scss/_mixin.scss";
@import "@/scss/toast.scss";
@import "@/scss/dialog.scss";

.moondayCard {
  width: 100%;
  max-width: 600px;
  min-height: 204px;
  border-radius: 20px;
  background: linear-gradient(145deg, #1f3448 0%, #15283a 100%);
  border: 1px solid rgba(122, 165, 200, 0.32);
  box-shadow: 0 14px 28px rgba(6, 14, 23, 0.36);
  padding: 24px 28px;
  margin: 0 auto 28px;
  cursor: pointer;
  @include mobile {
    width: 100%;
    min-height: 152px;
    border-radius: 8px;
    padding: 18px 16px;
    margin: 0 auto 24px;
  }
  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    &__option {
      .option__group__item {
        border: 1px solid rgba(122, 165, 200, 0.32);
        background: linear-gradient(145deg, #1f3448 0%, #15283a 100%);
        box-shadow: 0 8px 16px rgba(6, 14, 23, 0.34);
        transition: background-color 0.2s ease, transform 0.2s ease;
        &:hover {
          background: linear-gradient(145deg, #294863 0%, #1b344b 100%);
          transform: translateY(-1px);
        }
        img {
          filter: brightness(0) saturate(100%) invert(94%) sepia(9%) saturate(636%)
            hue-rotate(175deg) brightness(103%) contrast(93%);
        }
      }
    }
    &__info {
      display: flex;
      align-items: flex-start;
      &.infoWrap {
        flex-direction: column-reverse;
        .moondayCard__header__info__emotionGroup {
          margin-top: 8px;
        }
      }
      &__emotionGroup {
        display: flex;
        &__emotion {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin-right: 8px;
          @include center;
          @include mobile {
            width: 28px;
            height: 28px;
          }
          img {
            width: 21px;
            height: 21px;
            @include mobile {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
      &__text {
        &__title {
          color: #f4d7a0;
          font-size: 20px;
          line-height: 36px;
          display: flex;
          @include mobile {
            font-size: 16px;
            line-height: 28px;
          }
          &__platform {
            margin-left: 8px;
            margin-right: 8px;
            margin-top: 9px;
            height: 18px;
            padding: 2px 12px;
            background-color: rgba(17, 33, 47, 0.95);
            border: 1px solid rgba(122, 165, 200, 0.32);
            box-shadow: inset 0 1px 0 rgba(180, 213, 239, 0.18);
            border-radius: 50px;
            font-size: 10px;
            color: #d8e8f7;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            @include mobile {
              margin-top: 4px;
              font-size: 10px;
            }
          }
        }
        &__date {
          color: #a7bfd3;
          font-size: 16px;
          font-weight: 400;
          line-height: 18px;
          @include mobile {
            font-size: 12px;
          }
        }
      }
    }
  }
  &__line {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 12px 0 8px;
    span {
      height: 1px;
      background-color: rgba(137, 170, 196, 0.38);
      display: flex;
      flex-grow: 1;
    }
  }
  &__body {
    &__date {
      color: #a7bfd3;
      margin-bottom: 12px;
      font-size: 16px;
      @include mobile {
        font-size: 12px;
        margin-bottom: 8px;
      }
    }
    &__content {
      color: #d8e8f7;
      text-align: justify;
      font-size: 18px;
      font-weight: 400;
      line-height: 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      white-space: normal;
      word-break: break-all;
      @include mobile {
        font-size: 14px;
        line-height: 18px;
      }
      .keyword {
        display: inline-block;
        background-color: #c6dbf9;
      }
    }
  }
}
</style>
  